export default { 
  CertifPart: require('./CertifPart').default,
  CertifGrad: require('./CertifGrad').default,
  CertifPartBundling: require('./CertifPartBundling').default,
  CertifGradBundling: require('./CertifGradBundling').default,
  
}